import { render, staticRenderFns } from "./CargoList.vue?vue&type=template&id=9ced5df2&"
import script from "./CargoList.vue?vue&type=script&lang=js&"
export * from "./CargoList.vue?vue&type=script&lang=js&"
import style0 from "./CargoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports